import React from "react";
import { Link } from "react-router-dom";

const article = (props) => {
  let articlePhoto = require(`../../assets/${props.figure}.jpg`);
  const isExternal = props.link.indexOf("https://") > -1;
  const addClass = props.figure.substring(0, 5) === "news-" ? "full" : null;

  const content = (
    <div className="border">
      <figure className={addClass} style={{ backgroundImage: `url(${articlePhoto}` }} />

      <div>
        {/* dangerouslySetInnerHTML needed for HTML entities (&rsquo;, &nbsp;, etc.) in some titles */}
        <h3 dangerouslySetInnerHTML={{ __html: props.title }}></h3>
        <span className="date">{props.date}</span>

        <button className="toggle">
          <span>Read Article</span>
        </button>
      </div>
    </div>
  );

  // External link - use <a> tag with target="_blank"
  if (isExternal) {
    return (
      <a href={props.link} className="article" target="_blank" rel="noopener noreferrer">
        {content}
      </a>
    );
  }

  // Internal link - use React Router <Link>
  return (
    <Link to={`/news/${props.link}/`} className="article">
      {content}
    </Link>
  );
};

export default article;
